import { render, staticRenderFns } from "./MenuInner.vue?vue&type=template&id=8b4292f4&scoped=true"
import script from "./MenuInner.vue?vue&type=script&lang=js"
export * from "./MenuInner.vue?vue&type=script&lang=js"
import style0 from "./MenuInner.vue?vue&type=style&index=0&id=8b4292f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b4292f4",
  null
  
)

export default component.exports